import { StudentInvoicesPageContent } from "@/pages/home/studentInvoices/studentInvoices"
import { createFileRoute } from "@tanstack/react-router"

export const Route = createFileRoute("/home/facturen/")({
  component: RouteComponent,
})

function RouteComponent() {
  return <StudentInvoicesPageContent />
}
